export const EEmailType = {
  "0": "UNKNOWN",
  "1": "NEW_USER",
  "2": "PWD_RESET",
  "3": "PNR_DOC",
  "4": "PNR_OFFER",
  "5": "INVOICE",
  "6": "PNR_CONFIRM",
  "7": "TASK_MAIL",
  "8": "VOUCHER_DOC_BOOKED",
  "9": "VOUCHER_DOC_RESERVED",
  "10": "TNR_DOC",
  "11": "VOUCHER_OFFER",
  "12": "VOUCHER_ONCOMING_OPTION",
  "13": "RNR_DOC",
  "14": "HOTEL_RESERVATION_DOC",
  "15": "HOTEL_REISSUE_DOC",
  "16": "HOTEL_REVERSE_DOC",
  "17": "HOTEL_AGENCY_NOTE",
  "-1": "ALL"
};

export const EEmailStatus = {
  "1": "SENT",
  "2": "NOT_SENT",
  "3": "DELIVERED",
  "4": "NOT_DELIVERED",
  "5": "READ",
  "6": "NOT_READ",
  "7": "REPLIED",
  "8": "ERROR"
};

export const EEmailImportance = {
  "0": "UNKNOWN",
  "1": "LOW",
  "2": "NORMAL",
  "3": "HIGH"
};

export const EEmailIOType = {
  "0": "INCOMING",
  "1": "OUTGOING"
};

export const EEmailFromType = {
  "0": "UNKNOWN",
  "1": "NOREPLY",
  "2": "SERVICE_CENTER",
  "-1": "ALL"
};